module.exports = __webpack_public_path__ + "static/media/print&writing_recog_demo.a232160e.png";